import clsx from 'clsx'
import { CAL_HOURS, CAL_TOTAL_HEIGHT, HOUR_HEIGHT, formatHour } from '../model/calendarConstants'

export const CalendarTimeAxis = () => (
  <div className="relative select-none" style={{ height: CAL_TOTAL_HEIGHT }}>
    {CAL_HOURS.map((h, i) => (
      <div
        key={h}
        className="absolute right-1 flex items-center"
        style={{ top: i * HOUR_HEIGHT - 7, height: 14 }}
      >
        <span className={clsx("text-[12px] font-semibold text-gray-400 leading-none whitespace-nowrap", i == 0 && 'mt-2.5')}>
          {formatHour(h)}
        </span>
      </div>
    ))}
  </div>
)
